import type { BadgeTokens } from './types';

export const badge: BadgeTokens = {
  colors: {
    text: 'primary.50',
    bg: 'neutral.0',
  },
  space: {
    mr: '0',
    p: '1px',
  },
  transform: {
    base: 'none',
  },
};
